import React from 'react';

import { get } from 'lodash';

import { SORT_DIRECTION } from '../../types';
import currencyFormat from '../../utils/currencyFormat';
import getWordDecl from '../../utils/getWordDecl';

import OrdersBottom from './orders-bottom/orders-bottom';
import OrdersHeader from './orders-header/orders-header';
import OrdersList from './orders-list/orders-list';
import { FILTERS_UNION, ORDERS_FILTERS_TYPE, OrdersItemProps } from './types';

interface OrdersTableProps {
  data: OrdersItemProps[];
  onItemClick: (id: number) => void;
  onFilerChange: (name: FILTERS_UNION, direction: SORT_DIRECTION) => void;
  onPaginateBtnClick: () => void;
  filters: ORDERS_FILTERS_TYPE;
  showBottomAction: boolean;
  loading: boolean;
  count: number;
  total?: number;
  specialFields?: object;
}

const OrdersTable: React.FC<OrdersTableProps> = ({
  data,
  onItemClick,
  loading,
  showBottomAction = true,
  onPaginateBtnClick,
  filters,
  onFilerChange,
  count,
  total,
  specialFields,
}) => {
  const sum = specialFields ? get(specialFields, 'sum', 0) : 0;
  return (
    <div className="orders">
      <OrdersHeader filters={filters} onFilterChange={onFilerChange} />
      <OrdersList
        loading={loading}
        onItemClick={onItemClick}
        data={data}
        count={count}
      />
      {showBottomAction && !loading ? (
        <OrdersBottom onClick={onPaginateBtnClick} />
      ) : null}
      <div className="total-elements__container">
        {!!total &&
          `За указанный период найдено: ${total} ${getWordDecl(total || 0, [
            'заказ',
            'заказa',
            'заказов',
          ])} на сумму ${currencyFormat(sum)} `}
        {!total && `За указанный период ничего не найдено`}
      </div>
    </div>
  );
};

export default OrdersTable;
